import api from '../../../../services/api';

// Action Types
export const FETCH_SHOPIFY_CATEGORIES_START = 'FETCH_SHOPIFY_CATEGORIES_START';
export const FETCH_SHOPIFY_CATEGORIES_SUCCESS = 'FETCH_SHOPIFY_CATEGORIES_SUCCESS';
export const FETCH_SHOPIFY_CATEGORIES_FAILURE = 'FETCH_SHOPIFY_CATEGORIES_FAILURE';

export const CREATE_SHOPIFY_CATEGORY_START = 'CREATE_SHOPIFY_CATEGORY_START';
export const CREATE_SHOPIFY_CATEGORY_SUCCESS = 'CREATE_SHOPIFY_CATEGORY_SUCCESS';
export const CREATE_SHOPIFY_CATEGORY_FAILURE = 'CREATE_SHOPIFY_CATEGORY_FAILURE';

export const UPDATE_SHOPIFY_CATEGORY_START = 'UPDATE_SHOPIFY_CATEGORY_START';
export const UPDATE_SHOPIFY_CATEGORY_SUCCESS = 'UPDATE_SHOPIFY_CATEGORY_SUCCESS';
export const UPDATE_SHOPIFY_CATEGORY_FAILURE = 'UPDATE_SHOPIFY_CATEGORY_FAILURE';

export const DELETE_SHOPIFY_CATEGORY_START = 'DELETE_SHOPIFY_CATEGORY_START';
export const DELETE_SHOPIFY_CATEGORY_SUCCESS = 'DELETE_SHOPIFY_CATEGORY_SUCCESS';
export const DELETE_SHOPIFY_CATEGORY_FAILURE = 'DELETE_SHOPIFY_CATEGORY_FAILURE';

export const UPDATE_SHOPIFY_CATEGORIES_STATUS_START = 'UPDATE_SHOPIFY_CATEGORIES_STATUS_START';
export const UPDATE_SHOPIFY_CATEGORIES_STATUS_SUCCESS = 'UPDATE_SHOPIFY_CATEGORIES_STATUS_SUCCESS';
export const UPDATE_SHOPIFY_CATEGORIES_STATUS_FAILURE = 'UPDATE_SHOPIFY_CATEGORIES_STATUS_FAILURE';

export const SET_SHOPIFY_FILTERS = 'SET_SHOPIFY_FILTERS';
export const CLEAR_SHOPIFY_FILTERS = 'CLEAR_SHOPIFY_FILTERS';
export const CHANGE_SHOPIFY_PAGINATION = 'CHANGE_SHOPIFY_PAGINATION';

export const FETCH_AVAILABLE_KEYWORDS_SUCCESS = 'FETCH_AVAILABLE_KEYWORDS_SUCCESS';

/**
 * Fetch all Shopify categories với filters và pagination
 */
export const fetchShopifyCategories = (params = {}) => async (dispatch, getState) => {
    dispatch({ type: FETCH_SHOPIFY_CATEGORIES_START });
    
    try {
        const state = getState();
        const { filters, pagination } = state.shopifyCategories || {};
        
        // Merge params với current state
        const queryParams = {
            page: params.page || pagination?.current || 1,
            pageSize: params.pageSize || pagination?.pageSize || 50,
            search: params.search !== undefined ? params.search : filters?.searchText || '',
            isActive: params.isActive !== undefined ? params.isActive : 
                     (filters?.statusFilter === 'all' ? undefined : filters?.statusFilter),
            keywordType: params.keywordType || filters?.keywordTypeFilter || 'all',
            sortBy: params.sortBy || 'createdAt',
            sortOrder: params.sortOrder || 'DESC'
        };

        const response = await api.get('/shopify/categories', { params: queryParams });
        
        dispatch({
            type: FETCH_SHOPIFY_CATEGORIES_SUCCESS,
            payload: {
                categories: response.data.rows || [],
                pagination: response.data.pagination || {},
                filters: response.data.filters || {}
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        console.error('Error fetching Shopify categories:', error);
        dispatch({
            type: FETCH_SHOPIFY_CATEGORIES_FAILURE,
            payload: error.message
        });
        return { success: false, error: error.message };
    }
};

/**
 * Create a new Shopify category
 */
export const createShopifyCategory = (categoryData) => async (dispatch) => {
    dispatch({ type: CREATE_SHOPIFY_CATEGORY_START });
    
    try {
        const response = await api.post('/shopify/categories', categoryData);
        const newCategory = response.data?.data || response.data;
        
        dispatch({
            type: CREATE_SHOPIFY_CATEGORY_SUCCESS,
            payload: newCategory
        });

        return { success: true, data: newCategory };
    } catch (error) {
        console.error('Error creating Shopify category:', error);
        dispatch({
            type: CREATE_SHOPIFY_CATEGORY_FAILURE,
            payload: error.message
        });
        return { success: false, error: error.message };
    }
};

/**
 * Update a Shopify category
 */
export const updateShopifyCategory = (id, categoryData) => async (dispatch) => {
    dispatch({ type: UPDATE_SHOPIFY_CATEGORY_START });
    
    try {
        const response = await api.put(`/shopify/categories/${id}`, categoryData);
        const updatedCategory = response.data?.data || response.data;
        
        dispatch({
            type: UPDATE_SHOPIFY_CATEGORY_SUCCESS,
            payload: { id, ...updatedCategory }
        });

        return { success: true, data: updatedCategory };
    } catch (error) {
        console.error('Error updating Shopify category:', error);
        dispatch({
            type: UPDATE_SHOPIFY_CATEGORY_FAILURE,
            payload: error.message
        });
        return { success: false, error: error.message };
    }
};

/**
 * Delete a Shopify category
 */
export const deleteShopifyCategory = (id) => async (dispatch) => {
    dispatch({ type: DELETE_SHOPIFY_CATEGORY_START });
    
    try {
        await api.delete(`/shopify/categories/${id}`);
        
        dispatch({
            type: DELETE_SHOPIFY_CATEGORY_SUCCESS,
            payload: id
        });

        return { success: true };
    } catch (error) {
        console.error('Error deleting Shopify category:', error);
        dispatch({
            type: DELETE_SHOPIFY_CATEGORY_FAILURE,
            payload: error.message
        });
        return { success: false, error: error.message };
    }
};

/**
 * Update multiple Shopify categories status
 */
export const updateShopifyCategoriesStatus = (categoryIds, isActive) => async (dispatch) => {
    dispatch({ type: UPDATE_SHOPIFY_CATEGORIES_STATUS_START });
    
    try {
        await api.put('/shopify/categories/status/batch', { categoryIds, isActive });
        
        dispatch({
            type: UPDATE_SHOPIFY_CATEGORIES_STATUS_SUCCESS,
            payload: { categoryIds, isActive }
        });

        return { success: true };
    } catch (error) {
        console.error('Error updating Shopify categories status:', error);
        dispatch({
            type: UPDATE_SHOPIFY_CATEGORIES_STATUS_FAILURE,
            payload: error.message
        });
        return { success: false, error: error.message };
    }
};

/**
 * Search Shopify categories
 */
export const searchCategories = (searchText) => (dispatch, getState) => {
    dispatch({
        type: SET_SHOPIFY_FILTERS,
        payload: { searchText }
    });
    
    // Auto-fetch với search text mới
    return dispatch(fetchShopifyCategories({ search: searchText, page: 1 }));
};

/**
 * Filter by status
 */
export const filterByStatus = (statusFilter) => (dispatch, getState) => {
    dispatch({
        type: SET_SHOPIFY_FILTERS,
        payload: { statusFilter }
    });
    
    const isActive = statusFilter === 'all' ? undefined : statusFilter;
    return dispatch(fetchShopifyCategories({ isActive, page: 1 }));
};

/**
 * Filter by keyword type
 */
export const filterByKeywordType = (keywordTypeFilter) => (dispatch, getState) => {
    dispatch({
        type: SET_SHOPIFY_FILTERS,
        payload: { keywordTypeFilter }
    });
    
    return dispatch(fetchShopifyCategories({ keywordType: keywordTypeFilter, page: 1 }));
};

/**
 * Change pagination
 */
export const changePagination = (page, pageSize) => (dispatch, getState) => {
    dispatch({
        type: CHANGE_SHOPIFY_PAGINATION,
        payload: { page, pageSize }
    });
    
    return dispatch(fetchShopifyCategories({ page, pageSize }));
};

/**
 * Clear all filters
 */
export const clearFilters = () => (dispatch) => {
    dispatch({ type: CLEAR_SHOPIFY_FILTERS });
    return dispatch(fetchShopifyCategories({ page: 1 }));
};

/**
 * Fetch available keywords for filters
 */
export const fetchAvailableKeywords = () => async (dispatch) => {
    try {
        const response = await api.get('/shopify/categories/keywords');
        
        dispatch({
            type: FETCH_AVAILABLE_KEYWORDS_SUCCESS,
            payload: response.data.keywords || {}
        });

        return { success: true, data: response.data.keywords };
    } catch (error) {
        console.error('Error fetching available keywords:', error);
        return { success: false, error: error.message };
    }
};
